import React from 'react';
import { Link } from 'react-router-dom';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

const signoutcomps = () => {
    return (
        <>
            <Link className="nav-link item" to="/signup">
                sign up
                <FontAwesomeIcon icon="user" style={{marginLeft:"5px"}}/> 
                </Link>
            <Link className="nav-link item" to="/login">
                log in
                <FontAwesomeIcon icon="sign-in-alt" style={{marginLeft:"5px"}}/> 
                </Link>
       </> 
    )
}
export default signoutcomps